import React, { useState } from 'react'
import { Box, Button, Icon } from '@node-space/ui-components'
import { ellipseMiddleText } from '@node-space/utils'
import { ExternalReferenceForm } from './ExternalReferenceForm'

export interface ExternalReferenceCtaProps {
  customerReference: string
  externalReference: string
  refetchCustomerData: () => void
}

export const ExternalReferenceCta = ({
  customerReference,
  externalReference,
  refetchCustomerData,
}: ExternalReferenceCtaProps) => {
  const [isEditing, setIsEditing] = useState(false)

  const onEdit = () => {
    setIsEditing(true)
  }

  const onClose = () => {
    setIsEditing(false)
  }

  const onSuccess = () => {
    refetchCustomerData()
    onClose()
  }

  return (
    <>
      <Box flex align="center" gap={4}>
        {ellipseMiddleText(externalReference, 15, 15)}
        <Button
          variant="ghost"
          noPadding
          iconElement={<Icon name={externalReference ? 'SimplePencilCustom' : 'Plus'} />}
          onClick={onEdit}
          style={{ marginRight: '-4px' }}
        />
      </Box>
      {isEditing && (
        <ExternalReferenceForm
          customerReference={customerReference}
          initialExternalReference={externalReference}
          onClose={onClose}
          onSuccess={onSuccess}
        />
      )}
    </>
  )
}
